document.addEventListener("DOMContentLoaded", function () {
    $('[data-init="toast"]').toast('show');

    async function parseJsonResponse(response) {
        const responseText = await response.text();

        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

        return JSON.parse(responseText);
    }

    window.cockpitCaptchaSolved = function () {
        const errorTextElement = document.getElementById("error-text");
        const errorMessageElement = document.getElementById("error-message");

        if (errorTextElement && /reCAPTCHA/i.test(errorTextElement.textContent || "")) {
            errorTextElement.textContent = "";
        }

        if (errorMessageElement && !errorTextElement?.textContent) {
            errorMessageElement.style.display = "none";
            errorMessageElement.classList.remove("show");
        }
    };

    window.cockpitCaptchaExpired = function () {
        resetCaptchaWidget("reCAPTCHA expired. Please tick it again.");
    };

    window.cockpitCaptchaError = function () {
        resetCaptchaWidget("reCAPTCHA failed to load. Please refresh and try again.");
    };

    const userId = Cookies.get("user_id");
    const domain = Cookies.get("domain");
    const path = Cookies.get("path");
    const currentDomain = window.location.hostname;
    const currentPath = window.location.pathname.split("/").slice(0, -1).join("/");

    const twofa_token = localStorage.getItem("twofa_token");
    const isTwoFAPage = window.location.pathname.includes("twofa_verify.php");

    if (isTwoFAPage && !twofa_token) {
        const errorMessage = document.getElementById("error-message");
        const twofaForm = document.getElementById("twofa-form");

        if (errorMessage) {
            errorMessage.textContent = "Invalid access. Please log in again.";
            errorMessage.style.display = "block";
            errorMessage.classList.remove("login-error-hidden", "fade", "d-none");
            errorMessage.classList.add("show");
        }

        if (twofaForm) {
            const inputs = twofaForm.querySelectorAll("input, button");
            inputs.forEach(input => {
                input.disabled = true;
            });
        }

        setTimeout(() => {
            window.location.href = "index.php";
        }, 3000);
        return;
    }

    if (twofa_token && isTwoFAPage) {
        setupTwoFAVerification(twofa_token);
        return;
    }

    if (userId && domain === currentDomain && path === currentPath) {
        window.location.href = "dashboard.php";
    } else {
        Cookies.remove("user_id");
        Cookies.remove("username");
        Cookies.remove("name");
        Cookies.remove("avatar");
        Cookies.remove("domain");
        Cookies.remove("path");
        Cookies.remove("user_type");
        localStorage.removeItem("twofa_token");
    }

    const loginForm = document.forms.login_form;
    if (!loginForm) {
        return;
    }

    const redirectUrl = new URLSearchParams(window.location.search).get("redirect") || "dashboard.php";
    const recaptchaElement = document.querySelector(".g-recaptcha");

    function resetCaptchaWidget(message) {
        if (recaptchaElement && window.grecaptcha && typeof window.grecaptcha.reset === "function") {
            try {
                window.grecaptcha.reset();
            } catch (error) {
                console.warn("Unable to reset reCAPTCHA widget", error);
            }
        }

        if (message) {
            showError(message);
        }
    }

    loginForm.addEventListener("submit", function (event) {
        event.preventDefault();

        const csrfToken = loginForm.querySelector('input[name="csrf_token"]')?.value;
        const username = loginForm.username.value;
        const password = loginForm.password.value;
        const formData = new FormData();

        if (!csrfToken) {
            showError("CSRF token missing. Please refresh the page.");
            return;
        }

        formData.append("csrf_token", csrfToken);
        formData.append("username", username);
        formData.append("password", password);
        formData.append("redirect", redirectUrl);

        if (recaptchaElement) {
            if (!window.grecaptcha || typeof window.grecaptcha.getResponse !== "function") {
                showError("reCAPTCHA is still loading. Please wait a moment and try again.");
                return;
            }

            const recaptchaResponse = window.grecaptcha.getResponse().trim();
            if (!recaptchaResponse) {
                showError("Please complete the reCAPTCHA.");
                return;
            }

            formData.append("g-recaptcha-response", recaptchaResponse);
        }

        const submitButton = loginForm.querySelector('button[type="submit"]');
        const originalButtonText = submitButton.innerHTML;
        submitButton.disabled = true;
        submitButton.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Signing in...';

        fetch("./includes/login.php", {
            method: "POST",
            body: formData
        })
            .then(response => parseJsonResponse(response))
            .then(data => {
                submitButton.disabled = false;
                submitButton.innerHTML = originalButtonText;

                if (data.success) {
                    const expirationDate = new Date();
                    expirationDate.setTime(expirationDate.getTime() + (3 * 60 * 60 * 1000));
                    const newPath = window.location.pathname.split("/").slice(0, -1).join("/");

                    Cookies.set("user_id", data.user_id, { expires: expirationDate, path: "/" });
                    Cookies.set("username", data.username, { expires: expirationDate, path: "/" });
                    Cookies.set("name", data.name, { expires: expirationDate, path: "/" });
                    Cookies.set("avatar", data.avatar, { expires: expirationDate, path: "/" });
                    Cookies.set("domain", currentDomain, { expires: expirationDate, path: "/" });
                    Cookies.set("path", newPath, { expires: expirationDate, path: "/" });
                    Cookies.set("user_type", data.user_type, { expires: expirationDate, path: "/" });

                    window.location.href = redirectUrl;
                } else if (data.requires_2fa) {
                    if (data.twofa_token) {
                        localStorage.setItem("twofa_token", data.twofa_token);
                        window.location.href = "twofa_verify.php";
                    } else {
                        resetCaptchaWidget();
                        showError("Missing 2FA verification token");
                    }
                } else {
                    resetCaptchaWidget();
                    showError(data.message || "An error occurred during login");
                }
            })
            .catch(error => {
                console.error("Error:", error);
                submitButton.disabled = false;
                submitButton.innerHTML = originalButtonText;
                resetCaptchaWidget();
                showError("An error occurred during login. Please try again.");
            });
    });

    function showError(message) {
        const errorMessageElement = document.getElementById("error-message");
        const errorTextElement = document.getElementById("error-text");

        if (errorMessageElement && errorTextElement) {
            errorTextElement.textContent = message;
            errorMessageElement.style.display = "block";
            errorMessageElement.style.visibility = "visible";
            errorMessageElement.classList.remove("fade", "d-none");
            errorMessageElement.classList.add("show");
        } else {
            console.error("Could not find error message elements");
        }
    }

    function setupTwoFAVerification(token) {
        const twofaForm = document.getElementById("twofa-form");
        if (!twofaForm) {
            return;
        }

        const errorMessage = document.getElementById("error-message");

        twofaForm.addEventListener("submit", function (e) {
            e.preventDefault();

            const code = document.getElementById("twofa_code").value.trim();

            if (!/^\d{6}$/.test(code)) {
                if (errorMessage) {
                    const errorTextElement = errorMessage.querySelector('#error-text') || errorMessage;
                    if (errorTextElement !== errorMessage) {
                        errorTextElement.textContent = 'Please enter a valid 6-digit code';
                    } else {
                        errorMessage.textContent = 'Please enter a valid 6-digit code';
                    }
                    errorMessage.style.display = 'block';
                    errorMessage.classList.remove('fade');
                    errorMessage.classList.add('show');
                }
                return;
            }

            const formData = new FormData();
            formData.append("twofa_code", code);
            formData.append("twofa_token", token);

            const submitButton = twofaForm.querySelector('button[type="submit"]');
            const originalButtonText = submitButton.innerHTML;
            submitButton.disabled = true;
            submitButton.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Verifying...';

            fetch('./includes/login.php', {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    submitButton.disabled = false;
                    submitButton.innerHTML = originalButtonText;

                    if (data.success) {
                        const expirationDate = new Date();
                        expirationDate.setTime(expirationDate.getTime() + (3 * 60 * 60 * 1000));
                        const newPath = window.location.pathname.split("/").slice(0, -1).join("/");

                        Cookies.set("user_id", data.user_id, { expires: expirationDate, path: "/" });
                        Cookies.set("username", data.username, { expires: expirationDate, path: "/" });
                        Cookies.set("name", data.name, { expires: expirationDate, path: "/" });
                        Cookies.set("avatar", data.avatar, { expires: expirationDate, path: "/" });
                        Cookies.set("domain", data.domain, { expires: expirationDate, path: "/" });
                        Cookies.set("path", newPath, { expires: expirationDate, path: "/" });
                        Cookies.set("user_type", data.user_type, { expires: expirationDate, path: "/" });

                        localStorage.removeItem("twofa_token");

                        if (data.user_type === 'owner') {
                            window.location.href = 'admin.php';
                        } else {
                            window.location.href = 'dashboard.php';
                        }
                    } else {
                        if (errorMessage) {
                            const errorTextElement = errorMessage.querySelector('#error-text') || errorMessage;
                            if (errorTextElement !== errorMessage) {
                                errorTextElement.textContent = data.message || 'Invalid verification code';
                            } else {
                                errorMessage.textContent = data.message || 'Invalid verification code';
                            }
                            errorMessage.style.display = 'block';
                            errorMessage.classList.remove('fade');
                            errorMessage.classList.add('show');
                        }

                        document.getElementById('twofa_code').value = '';
                        document.getElementById('twofa_code').focus();

                        if (!data.requires_2fa) {
                            localStorage.removeItem("twofa_token");
                            setTimeout(() => {
                                window.location.href = 'index.php?error=' + encodeURIComponent(data.message || 'Authentication failed');
                            }, 2000);
                        }
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                    submitButton.disabled = false;
                    submitButton.innerHTML = originalButtonText;

                    if (errorMessage) {
                        const errorTextElement = errorMessage.querySelector('#error-text') || errorMessage;
                        if (errorTextElement !== errorMessage) {
                            errorTextElement.textContent = 'An error occurred. Please try again.';
                        } else {
                            errorMessage.textContent = 'An error occurred. Please try again.';
                        }
                        errorMessage.style.display = 'block';
                        errorMessage.classList.remove('fade');
                        errorMessage.classList.add('show');
                    }
                });
        });
    }
});